export const inputStyle =
  'w-full border h-[39px] items-center flex p-2 gap-3 rounded-[4px] mt-1';

export const headerStyle = 'font-bold text-black text-[16px]';
export const noteStyle = 'text-[#676767] text-[12px] mt-1';
